import { isAllowedToTransformEvents, isAllowedToDeliverEvents } from '@ion/api';
import buildPipelineOutputGate from './buildPipelineOutputGate';
import buildPlaybookOutputGate from './buildPlaybookOutputGate';
import buildServerResponseGate from './buildServerResponseGate';

export default function buildChainDisabledTabs({
  hasValidInput,
  clusterId,
  pipelineSelected,
  pipelineDataLoading,
  pipelineOutput,
  playbookOutput,
  deliverBuildError,
}) {
  const canTransformEvent = isAllowedToTransformEvents();
  const canDeliverEvent = isAllowedToDeliverEvents();

  const pipeline = buildPipelineOutputGate({
    hasValidInput,
    clusterId,
    pipelineSelected,
    pipelineDataLoading,
    canTransformEvent,
  });
  const playbook = buildPlaybookOutputGate({ pipelineOutput, canTransformEvent });
  const server = buildServerResponseGate({ playbookOutput, canDeliverEvent, deliverBuildError });

  return {
    pipelineOutputDisabled: pipeline.disabled,
    pipelineOutputDisabledTooltip: pipeline.tooltip,
    playbookOutputDisabled: playbook.disabled,
    playbookOutputDisabledTooltip: playbook.tooltip,
    serverResponseDisabled: server.disabled,
    serverResponseDisabledTooltip: server.tooltip,
  };
}
